function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M207.129 -2H-12V284.955H207.129V-2Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206.086 14.8694H13.0435V67.043H206.086V14.8694Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.564 84.782H85.5647V272.607H205.564V84.782Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.78 34.3647H95.0381V38.0283H143.78V34.3647Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.858 43.8843H88.5164V47.5478H149.858V43.8843Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.78 128.125H119.038V131.789H167.78V128.125Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.306 138.88H119.038V142.544H194.306V138.88Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.163 149.123H119.821V152.787H181.163V149.123Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.848 160.362H119.038V164.025H154.848V160.362Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.085 171.339H119.038V175.003H173.085V171.339Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.791 126.973H96.8221V132.941H102.791V126.973Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.791 137.728H96.8221V143.696H102.791V137.728Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.791 147.971H96.8221V153.939H102.791V147.971Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.791 159.209H96.8221V165.178H102.791V159.209Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.791 170.187H96.8221V176.155H102.791V170.187Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.78 182.386H119.038V186.049H167.78V182.386Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.306 193.141H119.038V196.804H194.306V193.141Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.163 203.384H119.821V207.047H181.163V203.384Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M154.848 214.622H119.038V218.286H154.848V214.622Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.085 225.6H119.038V229.264H173.085V225.6Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.791 181.233H96.8221V187.202H102.791V181.233Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.791 191.988H96.8221V197.957H102.791V191.988Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.791 202.231H96.8221V208.2H102.791V202.231Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.791 213.47H96.8221V219.438H102.791V213.47Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.791 224.448H96.8221V230.416H102.791V224.448Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.8083 25.4456C41.7406 25.4456 38.7417 26.3552 36.191 28.0596C33.6403 29.7639 31.6523 32.1863 30.4783 35.0206C29.3043 37.8548 28.9972 40.9734 29.5956 43.9822C30.1941 46.991 31.6714 49.7547 33.8406 51.9239C36.0098 54.0931 38.7735 55.5704 41.7823 56.1689C44.7911 56.7674 47.9098 56.4602 50.744 55.2862C53.5782 54.1123 56.0006 52.1242 57.7049 49.5735C59.4093 47.0228 60.319 44.024 60.319 40.9562C60.3069 36.8462 58.6689 32.908 55.7627 30.0018C52.8565 27.0956 48.9183 25.4576 44.8083 25.4456V25.4456ZM44.8083 30.0988C45.7286 30.0988 46.6283 30.3717 47.3935 30.883C48.1587 31.3943 48.7551 32.121 49.1073 32.9713C49.4595 33.8215 49.5516 34.7571 49.3721 35.6598C49.1925 36.5624 48.7494 37.3915 48.0986 38.0423C47.4478 38.693 46.6187 39.1362 45.7161 39.3158C44.8134 39.4953 43.8779 39.4032 43.0276 39.051C42.1773 38.6988 41.4506 38.1024 40.9393 37.3372C40.428 36.5719 40.1551 35.6723 40.1551 34.752C40.1592 33.5191 40.6508 32.338 41.5225 31.4662C42.3943 30.5944 43.5754 30.1029 44.8083 30.0988V30.0988ZM44.8083 52.4998C42.9701 52.4914 41.1617 52.0347 39.54 51.1692C37.9182 50.3038 36.5321 49.0557 35.5019 47.5334C35.5765 44.4312 41.7062 42.7236 44.8083 42.7236C47.9104 42.7236 54.0401 44.4312 54.1147 47.5334C53.0833 49.0546 51.6969 50.3017 50.0754 51.1671C48.454 52.0324 46.6462 52.4898 44.8083 52.4998Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M463.301 286.329H0V287.498H463.301V286.329Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M396.197 91.9189C396.197 91.9189 401.493 103.099 405.023 104.276L395.021 119.574L386.783 109.571C386.783 109.571 387.371 102.51 385.606 99.5683C383.841 96.6262 396.197 91.9189 396.197 91.9189Z",
  fill: "#FBBEBE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M387.96 101.922C394.134 101.922 399.139 96.9165 399.139 90.7421C399.139 84.5676 394.134 79.5623 387.96 79.5623C381.785 79.5623 376.78 84.5676 376.78 90.7421C376.78 96.9165 381.785 101.922 387.96 101.922Z",
  fill: "#FBBEBE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M372.661 170.766L375.603 179.004L379.133 174.885L376.17 165.502L372.661 170.766Z",
  fill: "#FBBEBE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M380.899 166.647C380.899 166.647 377.368 181.358 379.133 188.418C380.899 195.479 386.194 243.729 386.194 243.729L389.725 281.976L403.847 283.153L402.081 238.433L403.847 199.598L413.85 237.257V283.153L430.913 283.741L429.148 224.312C429.148 224.312 430.325 178.416 422.676 172.531C415.026 166.647 413.85 165.47 413.85 165.47L380.899 166.647Z",
  fill: "#0C161B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M392.667 281.387L391.49 285.506L389.725 290.802C389.725 290.802 384.429 301.393 393.255 299.628C402.081 297.863 400.905 293.744 400.905 293.744C400.905 293.744 403.847 291.979 403.258 291.39C402.67 290.802 402.67 281.976 402.67 281.976L392.667 281.387Z",
  fill: "#0C161B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M426.795 281.387L427.971 285.506L429.737 290.802C429.737 290.802 435.032 301.393 426.206 299.628C417.38 297.863 418.557 293.744 418.557 293.744C418.557 293.744 415.615 291.979 416.203 291.39C416.792 290.802 416.792 281.976 416.792 281.976L426.795 281.387Z",
  fill: "#0C161B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M395.021 112.513L402.217 101.922L415.615 108.983L417.38 170.178C417.38 170.178 409.731 165.47 397.963 171.355C386.194 177.239 378.545 173.12 378.545 173.12L385.606 146.641L382.664 111.337L386.872 107.517L395.021 112.513Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M386.873 106.403L384.429 108.394C384.429 108.394 369.13 116.044 368.542 121.339L379.133 150.172C379.133 150.172 382.075 156.644 379.722 158.998C377.368 161.351 375.015 167.236 375.603 170.178C376.191 173.12 372.072 185.476 376.78 185.476C381.487 185.476 392.667 157.233 392.078 146.053C391.49 134.873 391.083 105.589 386.873 106.403Z",
  fill: "#0C161B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M373.838 117.809L370.211 118.197C370.211 118.197 366.777 120.751 366.777 126.635C366.777 132.519 366.188 150.172 366.188 150.172C366.188 150.172 365.011 158.998 368.542 165.47C372.072 171.943 372.661 173.708 372.661 173.708L378.545 166.647V151.937L380.899 142.522L373.838 117.809Z",
  fill: "#0C161B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M400.448 99.5011L406.2 101.922C406.2 101.922 426.206 107.218 429.148 116.044L420.911 136.638C420.911 136.638 426.795 174.297 425.029 174.297H423.264C423.264 174.297 427.971 177.827 425.029 179.004C422.087 180.181 415.026 189.595 413.261 185.476C411.496 181.357 400.905 132.519 402.081 121.928C403.258 111.337 399.403 100.611 400.448 99.5011Z",
  fill: "#0C161B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M392.373 76.3261V75.1493H389.431C389.431 75.1493 384.723 72.2072 380.604 75.7377C376.486 79.2681 374.72 81.0334 374.72 81.0334L372.955 83.387L374.72 83.9754L372.955 85.7406H374.72L373.543 87.5059L376.842 91.919C376.842 91.919 376.486 87.5059 380.016 87.5059C383.546 87.5059 387.665 82.7986 387.665 82.7986L396.492 89.2711C396.492 89.2711 395.903 85.7573 397.963 85.749C397.963 85.749 398.845 76.9145 392.373 76.3261Z",
  fill: "#0C161B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M433.267 170.766L432.09 183.123C432.09 183.123 432.09 201.363 425.618 199.598C419.145 197.833 424.441 182.534 424.441 182.534L425.335 171.469L433.267 170.766Z",
  fill: "#FBBEBE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M420.322 113.102C420.322 113.102 427.972 110.16 430.325 118.986C432.679 127.812 435.621 145.464 435.621 145.464C438.08 151.703 438.08 158.643 435.621 164.882L433.856 173.708L423.853 172.531L421.499 152.525L419.145 127.224L420.322 113.102Z",
  fill: "#0C161B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M404.958 37.8441H252.741V38.7583H404.958V37.8441Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M252.741 57.0426C263.092 57.0426 271.483 48.6518 271.483 38.3012C271.483 27.9506 263.092 19.5598 252.741 19.5598C242.391 19.5598 234 27.9506 234 38.3012C234 48.6518 242.391 57.0426 252.741 57.0426Z",
  fill: "#D0CDE1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M252.741 57.0426C263.092 57.0426 271.483 48.6518 271.483 38.3012C271.483 27.9506 263.092 19.5598 252.741 19.5598C242.391 19.5598 234 27.9506 234 38.3012C234 48.6518 242.391 57.0426 252.741 57.0426Z",
  fill: "#D6D2E0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M338.22 57.0426C348.571 57.0426 356.962 48.6518 356.962 38.3012C356.962 27.9506 348.571 19.5598 338.22 19.5598C327.87 19.5598 319.479 27.9506 319.479 38.3012C319.479 48.6518 327.87 57.0426 338.22 57.0426Z",
  fill: "#2A1173"
}), /*#__PURE__*/React.createElement("path", {
  d: "M423.699 20.0169C420.083 20.0169 416.548 21.0892 413.541 23.0983C410.534 25.1074 408.191 27.9631 406.807 31.3041C405.423 34.6451 405.061 38.3215 405.766 41.8683C406.472 45.4151 408.213 48.673 410.77 51.2301C413.327 53.7872 416.585 55.5286 420.132 56.2341C423.679 56.9396 427.355 56.5776 430.696 55.1937C434.037 53.8098 436.893 51.4662 438.902 48.4594C440.911 45.4525 441.983 41.9175 441.983 38.3012C441.978 33.4536 440.05 28.8061 436.622 25.3783C433.194 21.9505 428.547 20.0224 423.699 20.0169Z",
  fill: "#C8BEE0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M250.158 46.2744L242.036 35.4459L244.961 33.2514L250.553 40.7068L276.26 15L278.846 17.5854L250.158 46.2744Z",
  fill: "#2A1173"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 463.301,
  height: 296,
  fill: "white"
})));

function SvgStep2Illustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 464,
    height: 296,
    viewBox: "0 0 464 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Illustration);
export default __webpack_public_path__ + "static/media/Step2-illustration.500aa79e.svg";
export { ForwardRef as ReactComponent };